const DEFAULT_DEV_URL = 'http://localhost:4000/api/v1';

const buildRelativeBase = () => {
  if (typeof window !== 'undefined' && window.location.origin) {
    return `${window.location.origin.replace(/\/$/, '')}/api/v1`;
  }
  return '/api/v1';
};

export const resolveApiBaseUrl = () => {
  const raw = import.meta.env.VITE_API_URL?.trim();

  if (raw) {
    const normalized = raw.replace(/\/$/, '');
    if (
      typeof window !== 'undefined' &&
      window.location.protocol === 'https:' &&
      normalized.startsWith('http://')
    ) {
      try {
        const parsed = new URL(normalized);
        parsed.protocol = 'https:';
        return parsed.toString().replace(/\/$/, '');
      } catch {
        return buildRelativeBase();
      }
    }
    return normalized;
  }

  if (import.meta.env.PROD) {
    return buildRelativeBase();
  }

  return DEFAULT_DEV_URL;
};

